import { vaultRequest } from './request';

const VGS_VALUE_QUERY = `
query VaultVgsValue($token: String!) {
  vaultVgsValue(value: $token)
}`;

export const getRawValue = async (token: string): Promise<string> => {
  const rawValueRes = await vaultRequest(VGS_VALUE_QUERY, {
    token,
  });
  const rawValueResJson = await rawValueRes.json();
  return rawValueResJson.data.vaultVgsValue;
};
